var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('HomeView'),_c('AboutView'),_c('WhatWeDo'),_c('Philosophy'),_c('Faq'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }